import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { Upload, Image as ImageIcon } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HeroEditor = ({ data, onChange, token }) => {
  const [uploading, setUploading] = useState(false);

  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(`${API}/upload/image`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      
      const imageUrl = `${BACKEND_URL}${response.data.url}`;
      handleChange('image', imageUrl);
      toast.success('Image uploaded successfully!');
    } catch (error) {
      toast.error('Failed to upload image');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg p-6 space-y-6">
      <h2 className="text-2xl font-bold text-slate-900">Hero Section</h2>

      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Title
          </label>
          <Input
            value={data.title}
            onChange={(e) => handleChange('title', e.target.value)}
            placeholder="Alcarias Hills"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Subtitle
          </label>
          <Input
            value={data.subtitle}
            onChange={(e) => handleChange('subtitle', e.target.value)}
            placeholder="Casa de Campo"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-2">
          Description
        </label>
        <Textarea
          value={data.description}
          onChange={(e) => handleChange('description', e.target.value)}
          rows={3}
          placeholder="Luxury escape meets authentic Portuguese countryside living"
        />
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Location
          </label>
          <Input
            value={data.location}
            onChange={(e) => handleChange('location', e.target.value)}
            placeholder="Alentejo, Portugal"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            CTA Button Text
          </label>
          <Input
            value={data.ctaText}
            onChange={(e) => handleChange('ctaText', e.target.value)}
            placeholder="Explore Properties"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-2">
          Background Image
        </label>
        <div className="flex items-center gap-4">
          <Input
            value={data.image}
            onChange={(e) => handleChange('image', e.target.value)}
            placeholder="Image URL"
            className="flex-1"
          />
          <label htmlFor="hero-image-upload">
            <Button
              type="button"
              variant="outline"
              disabled={uploading}
              onClick={() => document.getElementById('hero-image-upload').click()}
            >
              <Upload className="w-4 h-4 mr-2" />
              {uploading ? 'Uploading...' : 'Upload'}
            </Button>
          </label>
          <input
            id="hero-image-upload"
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            className="hidden"
          />
        </div>
        {data.image && (
          <div className="mt-4">
            <img
              src={data.image}
              alt="Hero preview"
              className="w-full h-48 object-cover rounded-lg"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroEditor;
